// extracted by mini-css-extract-plugin
export default {"root":"ReferralPage_root__BaMwH"};